const amazonDomains = new Set(
  'amazon.com amazon.co.uk amazon.ca amazon.com.au amazon.de amazon.fr amazon.it amazon.es amazon.nl amazon.com.be amazon.ie amazon.se amazon.pl amazon.co.jp amazon.in amazon.com.br amazon.com.mx amazon.ae amazon.sg amazon.sa amazon.com.tr amazon.eg amazon.co.za amzn.to amzn.eu'.split(
    ' ',
  ),
);
export function isAmazonUrl(value: string) {
  try {
    const host = new URL(value).hostname.toLowerCase();
    return [...amazonDomains].some((domain) => host === domain || host.endsWith('.' + domain));
  } catch {
    return false;
  }
}
export const PRICE_MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const DELIVERY_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
// A recorded price remains useful after its stock/freshness window expires.
// Keep requiring a valid check date: edits can deliberately invalidate old checks.
export function hasRecordedPrice(offer: {
  price: unknown;
  currency: string | null;
  priceCheckedAt: string | Date | null;
}, now = Date.now()) {
  return offer.price !== null && Number.isFinite(Number(offer.price)) &&
    Number(offer.price) > 0 && Boolean(offer.currency) &&
    recentlyChecked(offer.priceCheckedAt, Infinity, now);
}
export function recentlyChecked(
  value: string | Date | null | undefined,
  maxAge: number,
  now = Date.now(),
) {
  const time = value ? new Date(value).getTime() : NaN;
  return Number.isFinite(time) && time <= now && now - time < maxAge;
}
